export const ADD_TODO = 'ADD_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const TOGGLE_IS_DONE = 'TOGGLE_IS_DONE';
export const SET_PROGRESS = 'SET_PROGRESS';
export const TOGGLE_IS_SORTED = 'TOGGLE_IS_SORTED';
export const SORT_TODO_LIST = 'SORT_TODO_LIST';
export const INITIALIZE_TODO_LIST = 'INITIALIZE_TODO_LIST';
